import cn from './app/cn.json';

export default {
  ...cn,
};
